import React, { createContext, useState, useEffect } from 'react';
import { Apirequests } from '../utils/ApiRequests';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('token'));

  // Function to fetch user details
  const fetchUserDetails = async (authToken) => {
    try {
      const response = await Apirequests('users/userdetails','GET',{}, {
          token: `${authToken}`
        });

        if(response?.success){
          setUser(response.data);
        }
    } catch (error) {
      console.error('Error fetching user details:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  // Check token and fetch user details on mount
  useEffect(() => {
    if (token) {
      fetchUserDetails(token);
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (credentials) => {
    try {
      // Replace with your actual login API endpoint
      const response = await Apirequests('users/superuser/admin','POST', credentials);


      // const { token: authToken } = response.data;

      if(response?.success){
         const authToken=  response.token;
         localStorage.setItem('token', authToken);
         setToken(authToken);
         await fetchUserDetails(authToken);
         return true;
      }else{
        return false
      }
  
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, token }}>
      {children}
    </AuthContext.Provider>
  );
};